import axiosClient from "./../apiClient.js";

const baseEndpoint = "/vishwasthamandal";

export const vishwasthaMandalObject = {
  userName: "",
  id: 0,
  vishwasthaMandalTypeId: 0,
  vishwasthaMandalType: "",
  name: "",
  fromPeriod: "",
  fromPeriodId: 0,
  toPeriod: "",
  toPeriodId: 0,
  image: "",
};

export const getPreview = () => {
  return axiosClient.get(`${baseEndpoint}/getpreview`);
};

export const save = (data) => {
  return axiosClient.post(`${baseEndpoint}/save`, JSON.stringify(data));
};

export const update = (data) => {
  return axiosClient.post(`${baseEndpoint}/update`, JSON.stringify(data));
};

export const publish = (data) => {
  return axiosClient.post(`${baseEndpoint}/publish`, JSON.stringify(data));
};

export const deletePreview = (data) => {
  return axiosClient.post(
    `${baseEndpoint}/deletepreview`,
    JSON.stringify(data)
  );
};

export const deleteLive = (data) => {
  return axiosClient.post(`${baseEndpoint}/deletelive`, JSON.stringify(data));
};

export const getLive = () => {
  return axiosClient.get(`${baseEndpoint}/getlive`);
};

export const getLiveById = (id) => {
  return axiosClient.get(`${baseEndpoint}/getlivebyid?id=${id}`);
};

export const getPreviewByVishwasthaMandalType = (vishwasthaMandalType) => {
  return axiosClient.get(
    `${baseEndpoint}/getpreviewbyvishwasthamandaltype?vishwasthaMandalType=${vishwasthaMandalType}`
  );
};

export const getLiveByVishwasthaMandalType = (vishwasthaMandalType) => {
  return axiosClient.get(
    `${baseEndpoint}/getlivebyvishwasthamandaltype?vishwasthaMandalType=${vishwasthaMandalType}`
  );
};
